import { AskRequest, QueueView, QueueViewCountsResponse } from '@hone-automation/common';

/**
 * Categorize a single request into a QueueView based on its properties.
 *
 * Priority order:
 * 1. Completed: status === 'Closed'
 * 2. Blockers: priority === 'Blocker' AND not Closed
 * 3. Me: assignee === meId AND not Blocker AND not Closed
 * 4. Client: status === 'In Progress' AND not assigned to me AND not Blocker AND not Closed
 * 5. My Team: everything else (Open, not assigned to me, not In Progress)
 */
export function categorizeRequestByView(request: AskRequest, meId: string): QueueView {
  if (request.status === 'Closed') return 'Completed';
  if (request.priority === 'Blocker') return 'Blockers';
  if (request.assignee === meId) return 'Me';
  if (request.status === 'In Progress') return 'Client';
  return 'My Team';
}

/**
 * Compute view counts for all views from a local list of requests.
 */
export function computeLocalViewCounts(requests: AskRequest[], meId: string): QueueViewCountsResponse {
  const counts: QueueViewCountsResponse = {
    Blockers: 0,
    Me: 0,
    'My Team': 0,
    Client: 0,
    Completed: 0,
  };

  for (const request of requests) {
    const view = categorizeRequestByView(request, meId);
    counts[view]++;
  }

  return counts;
}

/**
 * Filter requests to only those matching the given view.
 */
export function filterRequestsByView(requests: AskRequest[], view: QueueView, meId: string): AskRequest[] {
  return requests.filter(request => categorizeRequestByView(request, meId) === view);
}
